export { default as registerValidation } from './register';
export { default as loginValidation } from './login';
export { default as resetValidation } from './reset';
export { default as newPasswordValidation } from './newPassword';
export { default as warnings } from './warnings';
export { default as userSettingValidation } from './userSetting';
export { default as passwordSettingsValidation } from './passwordSettings';
export { default as contactValidation } from './contact';
export { default as couponValidation } from './coupon';
